import { Component } from '@angular/core';
import { AboutCraftSection } from '../../../components/about/about-craft-section/about-craft-section';
import { AboutHeroSection } from '../../../components/about/about-hero-section/about-hero-section';
import { AboutManifestoSection } from '../../../components/about/about-manifesto-section/about-manifesto-section';
import { AboutPrinciplesSection } from '../../../components/about/about-principles-section/about-principles-section';
import { AboutRhythmSection } from '../../../components/about/about-rhythm-section/about-rhythm-section';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-about-us-page',
  imports: [
    AboutHeroSection,
    AboutManifestoSection,
    AboutCraftSection,
    AboutRhythmSection,
    AboutPrinciplesSection,
  ],
  templateUrl: './about-us-page.html',
  styleUrl: './about-us-page.scss',
})
export class AboutUsPage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('About Us');
  }
}
